import { render, staticRenderFns } from "./ListOrder.vue?vue&type=template&id=b97a31d0&scoped=true&"
import script from "./ListOrder.vue?vue&type=script&lang=js&"
export * from "./ListOrder.vue?vue&type=script&lang=js&"
import style0 from "./ListOrder.vue?vue&type=style&index=0&id=b97a31d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97a31d0",
  null
  
)

export default component.exports